/* popup-livret.js — popup « livret de recettes » (section popup-livret)
   Inscription par l'API client de Klaviyo (clé publique) dans la liste du livret ;
   le flow Klaviyo envoie ensuite le PDF. Tiré de la maquette maquettes/popup-livret/interactions.js. */
(function () {
  var pop = document.querySelector('[data-flv]');
  if (!pop) return;
  var boite = pop.querySelector('.flv__boite');
  var form = pop.querySelector('.flv__form');
  var champ = form.querySelector('input');
  var erreur = pop.querySelector('.flv__erreur');
  var btn = form.querySelector('.flv__btn');
  var libelle = btn.textContent;
  var etapeForm = pop.querySelector('[data-flv-etape="form"]');
  var etapeMerci = pop.querySelector('[data-flv-etape="merci"]');
  var rappel = document.querySelector('[data-flv-rappel]');
  var d = pop.dataset;
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLE = 'flv-livret';
  var DELAI_MIN = (d.delay === '' || isNaN(+d.delay) ? 5 : +d.delay) * 1000, PAUSE_JOURS = +d.pause || 30;
  var editeur = d.design === 'true';
  var rappelActif = false;

  function lire() { try { return JSON.parse(localStorage.getItem(CLE)) || {}; } catch (e) { return {}; } }
  function ecrire(o) { try { localStorage.setItem(CLE, JSON.stringify(o)); } catch (e) {} }
  function enPause() { var e = lire(); return e.inscrit || (e.ferme && Date.now() - e.ferme < PAUSE_JOURS * 864e5); }
  // Visiteurs arrivés depuis un e-mail Klaviyo : déjà abonnés
  var depuisEmail = /[?&](utm_source=klaviyo|_kx=)/.test(location.search);

  var avant = null;
  function ouvrir() {
    if (!pop.hidden) return;
    avant = document.activeElement;
    if (rappel) rappel.hidden = true;
    pop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
    // Pas de focus automatique dans le champ sur mobile : le clavier cacherait le panneau
    (window.matchMedia('(max-width:640px)').matches ? boite : champ).focus({ preventScroll: true });
  }
  function fermer(parUtilisateur) {
    if (pop.hidden) return;
    pop.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { pop.hidden = true; majRappel(); }, calme ? 0 : 320);
    if (parUtilisateur && !lire().inscrit && !editeur) {
      var e = lire(); e.ferme = Date.now(); ecrire(e);
      if (!e.rappelFerme) montrerRappel();
    }
    if (avant && avant.focus) avant.focus({ preventScroll: true });
  }

  pop.addEventListener('click', function (e) { if (e.target.closest('[data-flv-fermer]')) fermer(true); });
  document.addEventListener('keydown', function (e) {
    if (pop.hidden) return;
    if (e.key === 'Escape') fermer(true);
    if (e.key === 'Tab') {
      var f = [].filter.call(boite.querySelectorAll('button, input, a[href]'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // /client/subscriptions vaut accord e-mail : le profil ne prend que l'adresse (le champ subscriptions est refusé)
  function inscrire(mail) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(d.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: d.source,
            profile: { data: { type: 'profile', attributes: { email: mail } } }
          },
          relationships: { list: { data: { type: 'list', id: d.list } } }
        }
      })
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var mail = champ.value.trim();
    erreur.textContent = '';
    champ.removeAttribute('aria-invalid');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) {
      erreur.textContent = mail ? 'Cette adresse ne semble pas complète. Exemple : prenom@gmail.com' : 'Indiquez votre adresse e-mail pour recevoir le livret.';
      champ.setAttribute('aria-invalid', 'true');
      champ.focus();
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Envoi…';
    inscrire(mail).then(function () {
      etapeMerci.querySelector('[data-flv-mail]').textContent = mail;
      etapeForm.hidden = true;
      etapeMerci.hidden = false;
      etapeMerci.focus();
      ecrire({ inscrit: true });
    }).catch(function () {
      erreur.textContent = 'L’envoi n’a pas abouti. Vérifiez votre connexion et réessayez.';
    }).then(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      btn.textContent = libelle;
    });
  });

  // Ouverture à l'intention de sortie, après un temps minimum sur la page :
  // - ordinateur : la souris sort de la fenêtre par le haut (onglets, barre d'adresse, fermeture) ;
  // - mobile (sans souris) : remontée rapide après au moins un écran de défilement.
  var debut = Date.now(), armee = false;
  function declencher() {
    if (!armee || Date.now() - debut < DELAI_MIN || enPause() || !pop.hidden) return;
    armee = false;
    document.removeEventListener('mouseout', sortieSouris);
    window.removeEventListener('scroll', remontee);
    ouvrir();
  }
  function sortieSouris(e) { if (!e.relatedTarget && e.clientY <= 0) declencher(); }
  var dernierY = window.scrollY, dernierT = Date.now(), maxY = 0;
  function remontee() {
    var y = window.scrollY, t = Date.now(), dt = Math.max(t - dernierT, 1);
    if (y > maxY) maxY = y;
    // vitesse de remontée > 1,5 px/ms, une fois passé le premier écran
    if (maxY > innerHeight && y < dernierY && (dernierY - y) / dt > 1.5 && dernierY - y > 60) declencher();
    dernierY = y; dernierT = t;
  }
  function armer() {
    armee = true;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', sortieSouris);
    else window.addEventListener('scroll', remontee, { passive: true });
  }

  if (editeur) {
    // Éditeur de thème : le popup s'ouvre quand on sélectionne la section
    document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('[data-flv]') || e.target.contains(pop)) ouvrir(); });
    document.addEventListener('shopify:section:deselect', function () { fermer(false); });
  } else if (!depuisEmail) {
    if (!enPause()) {
      armer();
    } else if (!lire().inscrit && !lire().rappelFerme) {
      montrerRappel();
    }
  }

  // Bouton de rappel : seulement une fois le premier écran passé (il ne couvre pas les boutons du haut de page),
  // et jamais sur une fiche produit en mobile (zone d'ajout au panier)
  function montrerRappel() { rappelActif = true; majRappel(); }
  function majRappel() {
    if (!rappel) return;
    var mobileFiche = d.template === 'product' && window.matchMedia('(max-width:640px)').matches;
    rappel.hidden = !(rappelActif && pop.hidden && !mobileFiche && window.scrollY > innerHeight * 0.9);
  }
  if (rappel) window.addEventListener('scroll', majRappel, { passive: true });
  if (rappel) {
    rappel.querySelector('.flv-rappel__ouvrir').addEventListener('click', function () { rappelActif = false; ouvrir(); });
    rappel.querySelector('.flv-rappel__fermer').addEventListener('click', function () { var e = lire(); e.rappelFerme = true; ecrire(e); rappelActif = false; rappel.hidden = true; });
  }
})();
